class MistakeHandler {
  constructor () {
    this.mistakes = []
  }
  getMistakes() {
    return this.mistakes
  }
  addMistake(newMistakenLetter) {
    let other
    for (let i = 0; i < this.mistakes.length; i++) {
      other = this.mistakes[i].getMistakenLetter()
      if (newMistakenLetter.equals(other)) {
        return
      }
    }
    const letterToMistake = new Mistake(newMistakenLetter)
    this.mistakes.push(letterToMistake)
  }
}

class Mistake {
  constructor(mistakenLetter) {
    this.mistaken = mistakenLetter
    this.strength = 5
  }
  updateStrength() {
    this.strength++
  }
  getStrength() {
    return this.strength
  }
  getMistakenLetter() {
    return this.mistaken
  }
}

export { MistakeHandler, Mistake}
